import { ntbActionType } from '../../actionTypes';

export const lenderListSuccessAction = (responseData, data) => (dispatch) => {
  dispatch({
    type: ntbActionType.INIT_LENDER_LIST_SCREEN,
    payload: {
      ...responseData,
      mobileNo: data && data.hasOwnProperty('mobile') ? data.mobile : '',
    },
  });
};



// WEBPACK FOOTER //
// ./actions/ntbAction/lenderListSuccessAction.js